module.exports = __webpack_public_path__ + "img/1716358145361-WhatsApp Image 2024-05-22 at 14.04.45.jpeg.f5365ecf.webp";